export const ThreeLinkIcon = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="102"
      height="102"
      viewBox="0 0 102 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_b_1794_3688)">
        <rect
          width="102"
          height="102"
          rx="12.5446"
          fill="white"
          fillOpacity="0.1"
        />
        <path
          d="M72.875 24.7497C70.9416 24.7512 69.0878 25.5199 67.7207 26.8871C66.3536 28.2542 65.5849 30.1079 65.5833 32.0413C65.5833 33.0826 65.8108 34.0713 66.2075 34.9726L60.5054 41.3863C58.5684 40.0493 56.2704 39.3331 53.9167 39.333C51.7583 39.333 49.7633 39.963 48.0279 40.9838L41.3954 34.3543L41.3283 34.4213C41.9 33.2605 42.25 31.9684 42.25 30.583C42.25 28.8524 41.7368 27.1607 40.7754 25.7218C39.8139 24.2828 38.4473 23.1613 36.8485 22.4991C35.2496 21.8368 33.4903 21.6635 31.793 22.0011C30.0956 22.3388 28.5365 23.1721 27.3128 24.3958C26.0891 25.6195 25.2558 27.1786 24.9181 28.876C24.5805 30.5733 24.7538 32.3326 25.4161 33.9315C26.0783 35.5303 27.1998 36.8969 28.6388 37.8584C30.0777 38.8198 31.7694 39.333 33.5 39.333C34.8854 39.333 36.1746 38.983 37.3383 38.4113L37.2713 38.4784L43.9038 45.108C42.8323 46.8873 42.2609 48.9227 42.25 50.9997C42.25 53.9076 43.3583 56.5384 45.1229 58.5859L37.6067 66.0993C36.7642 65.7621 35.8657 65.5869 34.9583 65.583C30.9392 65.583 27.6667 68.8526 27.6667 72.8747C27.6667 76.8968 30.9392 80.1663 34.9583 80.1663C38.9775 80.1663 42.25 76.8968 42.25 72.8747C42.25 71.9384 42.0575 71.0488 41.7338 70.2234L50.0113 61.9459C51.2392 62.3834 52.54 62.6663 53.9167 62.6663C60.3508 62.6663 65.5833 57.4338 65.5833 50.9997C65.5833 49.1447 65.1079 47.4151 64.335 45.8547L70.5096 38.9043C71.2563 39.1609 72.0438 39.333 72.875 39.333C76.8971 39.333 80.1667 36.0634 80.1667 32.0413C80.1667 28.0193 76.8971 24.7497 72.875 24.7497ZM53.9167 56.833C50.6996 56.833 48.0833 54.2168 48.0833 50.9997C48.0833 47.7826 50.6996 45.1663 53.9167 45.1663C57.1338 45.1663 59.75 47.7826 59.75 50.9997C59.75 54.2168 57.1338 56.833 53.9167 56.833Z"
          fill="white"
        />
        <rect
          x="0.418153"
          y="0.418153"
          width="101.164"
          height="101.164"
          rx="12.1264"
          stroke="url(#paint0_linear_1794_3688)"
          strokeWidth="0.836306"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_1794_3688"
          x="-21.744"
          y="-21.744"
          width="145.488"
          height="145.488"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="10.872" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1794_3688"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1794_3688"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1794_3688"
          x1="9.12934"
          y1="-9.36905e-07"
          x2="55.009"
          y2="61.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
